module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/eur-dc472c38de3cca1b650ad4d0164448ad.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/eur.svg
// module id = E/aD
// module chunks = 24